import { useRef, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export default function SignaturePad({ onSave, saving }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasSig, setHasSig] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.lineTo(x, y); ctx.stroke(); setHasSig(true); };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setHasSig(false); };
  const save = () => onSave(canvasRef.current.toDataURL("image/png"));

  return (
    <div>
      <div className="relative bg-white border-2 border-dashed border-slate-300 rounded-xl">
        <canvas ref={canvasRef} data-testid="customer-signature-pad"
          className="w-full h-44 touch-none rounded-xl"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {!hasSig && <span className="absolute inset-0 flex items-center justify-center text-slate-300 pointer-events-none text-sm">Sign here</span>}
      </div>
      <div className="flex gap-2 mt-3">
        <Button data-testid="signature-clear-button" variant="outline" onClick={clear} className="flex-1">Clear</Button>
        <Button data-testid="signature-save-button" onClick={save} disabled={!hasSig || saving} className="flex-1 bg-navy hover:bg-navy-light">{saving ? "Saving…" : "Save Signature"}</Button>
      </div>
    </div>
  );
}
